export default __webpack_public_path__ + "_/images/b-day/ribbon-e735d7f4128d9b95f7f73afc399fb03a82b81bc691275fdf52b49f8db3916293.svg";